import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { firstValueFrom } from 'rxjs';
import {
  BuildingSectionDeleteImpactDto,
  BuildingSectionService,
} from '@artemis-software/wr-api';

@Component({
  standalone: false,
  selector: 'wr-building-section-delete-dialog',
  templateUrl: './building-section-delete-dialog.component.html',
  styleUrls: ['./building-section-delete-dialog.component.scss'],
})
export class BuildingSectionDeleteDialogComponent implements OnInit {

  private readonly dialogRef = inject(NbDialogRef);
  private readonly buildingSectionService = inject(BuildingSectionService);

  @Input() title = '';
  @Input() message = '';
  @Input() buildingSectionIds: string[] = [];

  readonly impact = signal<BuildingSectionDeleteImpactDto | null>(null);
  readonly loading = signal(true);

  async ngOnInit(): Promise<void> {
    if (this.buildingSectionIds.length === 0) {
      this.loading.set(false);
      return;
    }
    try {
      const result = await firstValueFrom(
        this.buildingSectionService.getDeleteImpact({ buildingSectionIds: this.buildingSectionIds }),
      );
      this.impact.set(result);
    } catch {
      this.impact.set(null);
    } finally {
      this.loading.set(false);
    }
  }

  hasImpact(): boolean {
    const i = this.impact();
    return !!i && (i.inspectionEntryCount > 0 || i.buildingEquipmentCount > 0);
  }

  onDelete() {
    this.dialogRef.close(true);
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
